import gql from "graphql-tag";
import {
  GetUsers as GetUsersGenerated,
  GetUsersVariables as GetUsersVariablesGenerated,
  GetUsers_userConnections_users as UserDataGenerated,
} from "core/queries/__generated__/GetUsers";

export interface UserData extends UserDataGenerated {}
export interface GetUsersResponse extends GetUsersGenerated {}
export interface GetUsersVariables extends GetUsersVariablesGenerated {}

export const getUsers = gql`
  query GetUsers($filterCompanies: [ID!], $filterCity: ID, $ids: [ID!]) {
    userConnections(
      filter: { companyIds: $filterCompanies, cityId: $filterCity, ids: $ids }
    ) {
      users {
        id
        name
        firstName
        lastName
        email
        avatar {
          id
          url
        }
        cleaningCompany {
          id
        }
        dispatchRoles {
          name
        }
        tags {
          id
          name
          tagType
        }
        tomTeamMember {
          id
          city {
            id
            timezone
          }
        }
        roles
      }
    }
  }
`;
